import React from 'react'
import { Card } from 'react-bootstrap'

const HomeOfficeBanner = () => {
  return (
    <>
    <Card className='no-border rounded-0 text-center py-5 py-md-0'>
        <Card.Title className='home-office-title'> Home Office </Card.Title>
        <Card.Img src={process.env.PUBLIC_URL + "assets/digital-twin/images/office.jpg"} alt="Card image" className="banner-image rounded-0"  />
        {/* <Card.ImgOverlay className="digital-twin-banner-overlay">
            <Card.Title className='digital-twin-banner-text'> OUR AMAZING WORKS </Card.Title>
           <div><Card.Title className='digital-twin-banner-text second-line-text'> DIGITAL TWIN </Card.Title></div> 
		</Card.ImgOverlay> */}
    </Card>
      
    </>
  )
}

export default HomeOfficeBanner
